export default __webpack_public_path__ + "static/bg-alpen-9355362cf66a0dc92b55fe53b2598b31.jpg";